import { Component, ViewEncapsulation, OnInit, Input, ElementRef, ViewChild, forwardRef, OnChanges, SimpleChanges, Output, EventEmitter, ComponentRef } from "@angular/core";
import * as moment_ from 'moment'; const moment = moment_
import { OverlayRef } from "@angular/cdk/overlay";
import { ComponentPortal } from "@angular/cdk/portal";
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from "@angular/forms";
import { NpInput } from "../../input";
import { NpDatePickerService, MonthData } from "../date-picker.service";
import { NotifyService } from "../../shared/services/notify.service";
import { NpDatePickerPopup } from "../components/date-picker-popup";

/**
 * Month pickerç»ä»¶
 */
@Component({
  selector: `np-month-picker`,
  templateUrl: 'month-picker.html',
  styleUrls: ['month-picker.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NpMonthPicker),
      multi: true,
    }
  ]
})

export class NpMonthPicker implements OnInit, OnChanges, ControlValueAccessor {

  /**æ ç­¾ */
  @Input() label: string;
  /**æ¯å¦å¿å¡«ï¼trueä»å¨æ ç­¾åé¢æ·»å çº¢è²*å·ï¼ falseä¸å */
  @Input() isRequired: boolean;
  /**Placeholder */
  @Input() placeholder: string = '';
  /**æ ¡éªéè¯¯æ¶æ¾ç¤ºéè¯¯ä¿¡æ¯ */
  @Input() errorMessage: string;
  /**æ¯å¦ç¦ç¨ */
  @Input() isDisabled: boolean;

  /**å·²éæ¶é´ */
  @Input() date: moment_.Moment | string = null;
  /**æ¶é´å±ç¤ºæ ¼å¼ */
  @Input() format: string = 'YYYY-MM';

  @Output() onMonthChanged = new EventEmitter<any>();

  @ViewChild('monthPickerInput') monthPickerInput: NpInput;

  datePickerPopupRef: ComponentRef<NpDatePickerPopup>;
  private overlayRef: OverlayRef;
  isHover: boolean = false;

  private emitChange = (_: any) => { };

  /**æ¥æè¾å¥æ¡ææ¬å¼ï¼æ¯å½this.dateæ¹åæ¶æ­¤å¼ä¼åæ­¥æ¹å*/
  value: string;

  constructor(private datePickerService: NpDatePickerService) { }

  ngOnInit() {
    this.overlayRef = this.datePickerService.getOverlayRef(this.monthPickerInput.npInput);
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  onToggleDatePickerPopup() {
    if (this.isDisabled) {
      return;
    }

    if (this.overlayRef.hasAttached()) {
      this.closePopup();
      return;
    }

    this.datePickerPopupRef = this.overlayRef.attach(new ComponentPortal(NpDatePickerPopup));
    this.datePickerPopupRef.instance.date = moment(this.date);
    this.datePickerPopupRef.instance.datePickerType = 'month-picker';
    this.datePickerPopupRef.instance.isShowMonthsPanel = true;
    this.subscribeNotifyEvents();

    this.overlayRef.backdropClick().subscribe(() => {
      this.closePopup();
    });
  }

  onBlur(data: { value: any, event: any }) {
    if (this.datePickerService.isValid(data.value)) {
      this.date = moment(data.value, this.format).clone();
    } else {
      // å¦æè¾å¥æ¥æä¸åæ³ï¼é»è®¤å½åæ¶é´
      this.date = moment().clone();
    }

    this.syncValue();
    this.emitChange(this.date);
    this.onMonthChanged.emit(this.date);
  }

  onClear() {
    if (this.isDisabled) {
      return;
    }

    this.date = null;
    this.syncValue();
    this.emitChange(this.date);
    this.onMonthChanged.emit(this.date);
  }

  onMouseenter() {
    this.isHover = true;
  }

  onMouseleave() {
    this.isHover = false;
  }

  //#region Private methods

  /**æ¯æ¬¡this.dateæ¹åæ¶ï¼è¿ä¸ªæ¹æ³é½å¿é¡»è¦è°ç¨ */
  private syncValue() {
    if (this.date && this.datePickerService.isValid(this.date)) {
      this.value = moment(this.date, this.format).format(this.format);
    } else {
      this.value = '';
    }
  }

  private closePopup() {
    if (this.overlayRef.hasAttached) {
      this.overlayRef.detach();
    }
  }

  private subscribeNotifyEvents() {
    this.datePickerPopupRef.instance.onMonthClicked.subscribe((res: MonthData) => {
      this.emitDataAndClosePopup(res.date);
    });
  }

  private emitDataAndClosePopup(date: moment_.Moment) {
    this.date = date;
    this.syncValue();
    this.emitChange(this.date);
    this.onMonthChanged.emit(this.date);
    this.monthPickerInput.focus();
    this.closePopup();
  }
  //#endregion

  //#region Implement for ControlValueAccessor
  writeValue(obj: any): void {
    this.date = obj;
    this.syncValue();
  }

  registerOnChange(fn: any): void {
    this.emitChange = fn;
  }

  registerOnTouched(fn: any): void { }
  //#endregion
}